export enum PlayerEvent {
  'loadstart' = 'loadstart',
  'progress' = 'progress',
  'suspend' = 'suspend',
  'abort' = 'abort',
  'error' = 'error',
  'emptied' = 'emptied',
  'stalled' = 'stalled',
  'loadedmetadata' = 'loadedmetadata',
  'loadeddata' = 'loadeddata',
  'canplay' = 'canplay',
  'canplaythrough' = 'canplaythrough',
  'playing' = 'playing',
  'waiting' = 'waiting',
  'seeking' = 'seeking',
  'seeked' = 'seeked',
  'ended' = 'ended',
  'durationchange' = 'durationchange',
  'timeupdate' = 'timeupdate',
  'play' = 'play',
  'pause' = 'pause',
  'ratechange' = 'ratechange',
  'resize' = 'resize',
  'volumechange' = 'volumechange',
  'adserror' = 'adserror',
}
